export enum TranslationKeyEnum {
  // Common
  Loading = 'loading',
  Error = 'error',
  Success = 'success',
  Save = 'save',
  Cancel = 'cancel',
  Delete = 'delete',
  Edit = 'edit',
  Retry = 'retry',
  View = 'view',
  Search = 'search',
  Filter = 'filter',
  Sort = 'sort',
  Start = 'start',
  ViewAll = 'viewAll',
  ViewPastReports = 'viewPastReports',
  ViewPastReportsAndInsights = 'viewPastReportsAndInsights',
  ShowMore = 'showMore',
  ShowLess = 'showLess',
  LearnMore = 'learnMore',
  Apply = 'apply',
  Updated = 'updated',
  HillsPhone = 'hillsPhone',
  HillsHours = 'hillsHours',
  EmailUs = 'emailUs',
  HillsEmail = 'hillsEmail',

  // Navigation
  Home = 'home',
  Help = 'help',
  Overview = 'overview',
  Reports = 'reports',
  ReportsDescription = 'reportsDescription',
  Resources = 'resources',
  Settings = 'settings',
  Teams = 'teams',
  Profile = 'profile',
  Logout = 'logout',
  Login = 'login',
  MenuButton = 'menuButton',
  FoodShelterLoveLogo = 'foodShelterLoveLogo',
  Account = 'Account',
  ChevronRight = 'chevronRight',

  // Footer
  ContactUs = 'contactUs',
  Tutorials = 'tutorials',
  FAQs = 'faqs',
  Language = 'language',
  CopyrightNotice = 'copyrightNotice',
  StayInformed = 'stayInformed',
  GetUpdates = 'getUpdates',
  JoinOurList = 'joinOurList',
  NeedHelp = 'needHelp',
  PetParents = 'petParents',
  Adoptions = 'adoptions',
  Insights = 'insights',
  HillsVetCom = 'hillsVetCom',
  ShopHillsPetCom = 'shopHillsPetCom',
  SiteMap = 'siteMap',
  Legal = 'legal',
  PrivacyPolicy = 'privacyPolicy',
  TermsAndConditions = 'termsAndConditions',
  DoNotSellMyInfo = 'doNotSellMyInfo',

  // Orders
  Orders = 'orders',
  AllOrders = 'allOrders',
  Reorder = 'reorder',
  StartNewOrder = 'startNewOrder',
  ViewAllOrders = 'viewAllOrders',
  StartWithPastOrder = 'startWithPastOrder',
  OrderCutOffDate = 'OrderCutOffDate',
  PlanYourWeeklyDelivery = 'planYourWeeklyDelivery',
  StartYourNextOrder = 'startYourNextOrder',
  TrackOrder = 'trackOrder',
  ViewOrder = 'viewOrder',
  TrackingNotAvailable = 'trackingNotAvailable',
  TrackingNotAvailableDescription = 'trackingNotAvailableDescription',
  TrackingNotAvailableHelp = 'trackingNotAvailableHelp',
  ViewOrderDetails = 'viewOrderDetails',
  Understood = 'understood',
  OrderNumber = 'orderNumber',
  LoadingOrders = 'loadingOrders',
  NoOrdersInProgress = 'noOrdersInProgress',
  NoRecentCompletedOrders = 'noRecentCompletedOrders',
  InProgress = 'inProgress',
  Complete = 'complete',
  Open = 'open',
  Cancelled = 'cancelled',
  Rejected = 'rejected',
  SelectALocation = 'selectALocation',
  AllLocations = 'allLocations',
  DefaultLocation = 'defaultLocation',

  // Home page
  Welcome = 'welcome',
  RecentActivity = 'recentActivity',
  QuickActions = 'quickActions',

  // Reports
  AdoptionHeader = 'Adoption reports',
  ReportsTitle = 'reportsTitle',
  GenerateReport = 'generateReport',
  ExportReport = 'exportReport',
  ReportPeriod = 'reportPeriod',
  PetParentReports = 'petParentReports',
  PetParentReportsTooltipTitle = 'petParentReportsTooltipTitle',
  PetParentReportsTooltipDescription1 = 'petParentReportsTooltipDescription1',
  PetParentReportsTooltipDescription2 = 'petParentReportsTooltipDescription2',
  HillsOptInGuide = 'HillsOptInGuide',
  PetParentsOptedIns = 'petParentsOptedIns',
  PetszelReportsTooltipTitle = 'petszelReportsTooltipTitle',
  PetszelReportsTooltipDescription = 'petszelReportsTooltipDescription',
  PetParentReportsSubmitTooltipTitle = 'petParentReportsSubmitTooltipTitle',
  PetParentReportsSubmitTooltipTitleHomePage = 'PetParentReportsSubmitTooltipTitleHomePage',
  PetParentReportsSubmitTooltipDescription = 'petParentReportsSubmitTooltipDescription',
  PetParentReportsSubmitDeadlineTooltip = 'petParentReportsSubmitDeadlineTooltip',
  PetszelPetParentReportTooltipTitle = 'PetszelPetParentReportTooltipTitle',
  PetszelAdoptionReportTooltipTitle = 'PetszelAdoptionReportTooltipTitle',
  AdoptionReports = 'adoptionReports',
  AdoptionReportSingular = 'AdoptionReportSingular',
  SubmitOptedInPetParents = 'submitOptedInPetParents',
  SubmitAdoptionTotals = 'submitAdoptionTotals',
  LoadingPetParentReports = 'loadingPetParentReports',
  LoadingAdoptionReports = 'loadingAdoptionReports',
  NoCurrentPetParentReports = 'noCurrentPetParentReports',
  NoCurrentAdoptionReports = 'noCurrentAdoptionReports',
  SubmitPetParentReport = 'submitPetParentReport',
  SubmitMonthlyAdoptions = 'submitMonthlyAdoptions',
  WeekOf = 'weekOf',
  WasDue = 'wasDue',
  Due = 'due',
  DueOn = 'dueOn',
  MissedReport = 'missedReport',
  AllReports = 'allReports',
  AdoptionTooltipPrefix = 'adoptionTooltipPrefix',
  AdoptionTooltipLinkText = 'adoptionTooltipLinkText',
  AdoptionTooltipSuffix = 'adoptionTooltipSuffix',
  NoAdoptionReportsHeader = 'noAdoptionReportsHeader',
  NoAdoptionReportsDescription = 'noAdoptionReportsDescription',
  NoPetParentReportsHeader = 'noPetParentReportsHeader',
  NoPetParentReportsDescription = 'noPetParentReportsDescription',
  NewShelterUserWelcomeTitle = 'NewShelterUserWelcomeTitle',
  NewShelterUserAdoptonReportWelcomeTitle = 'NewShelterUserAdoptonReportWelcomeTitle',
  PetParentReportSubmittedTitle = 'petParentReportSubmittedTitle',
  PetParentReportSubmittedCanAddMoreDescription = 'petParentReportSubmittedCanAddMoreDescription',
  AdoptionReportSubmittedTitle = 'AdoptionReportSubmittedTitle',
  AdoptionReportSubmittedNextWindow = 'AdoptionReportSubmittedNextWindow',
  AdoptionReportMissedSubmissionTitle = 'AdoptionReportMissedSubmissionTitle',
  SubmittingReport = 'SubmittingReport',
  FilterReportsByStatusAriaLabel = 'filterReportsByStatusAriaLabel',

  // Reports Page
  All = 'all',
  Missed = 'missed',
  Late = 'late',
  MissedReports = 'missedReports',
  ViewReport = 'viewReport',
  SubmitReport = 'submitReport',
  Submitting = 'Submitting',
  DownloadTemplate = 'downloadTemplate',
  Template = 'Template',
  NewTemplate = 'newTemplate',
  Instructions = 'Instructions',
  PetParentReportsSectionTitle = 'petParentReportsSectionTitle',
  ReportTimeframe = 'reportTimeframe',
  Status = 'status',
  TotalOptIns = 'totalOptIns',
  TotalOptInsValue = 'totalOptInsValue',
  TotalOptInsSingular = 'totalOptInsSingular',
  TotalOptInsPlural = 'totalOptInsPlural',
  UniquePetParentOptIns = 'uniquePetParentOptIns',
  TotalPetsSingular = 'totalPetsSingular',
  TotalPetsPlural = 'totalPetsPlural',
  UploadMethod = 'uploadMethod',
  LastModified = 'lastModified',
  LastEdited = 'lastEdited',
  DueSoon = 'dueSoon',
  Submitted = 'submitted',
  LateSubmission = 'lateSubmission',
  ReportSupportTextWithLinks = 'reportSupportTextWithLinks',
  MissedReportsBannerMessage = 'missedReportsBannerMessage',
  MissedReportsBannerSubtitle = 'missedReportsBannerSubtitle',
  AdoptionReportSuccessHeader = 'AdoptionReportSuccessHeader',
  PetParentReportSuccessHeader = 'PetParentReportSuccessHeader',
  NoPetParentsToReview = 'NoPetParentsToReview',
  AutomatedSync = 'automatedSync',
  AdoptionCount = 'adoptionCount',

  // Modal Components
  CloseModal = 'closeModal',
  BackToReports = 'backToReports',
  BackToAllReports = 'BackToAllReports',
  SelectSubmissionMethod = 'selectSubmissionMethod',
  PetParentReport = 'petParentReport',
  UploadSpreadsheet = 'uploadSpreadsheet',
  ManualEntry = 'manualEntry',
  ManualUpload = 'manualUpload',
  ReportZeroPetParents = 'reportZeroPetParents',
  ContinueToReview = 'continueToReview',
  AddPet = 'addPet',
  AddAnotherPet = 'addAnotherPet',
  ReviewSubmission = 'reviewSubmission',
  DeletePetParentData = 'deletePetParentData',
  ConfirmDeletePetParent = 'confirmDeletePetParent',
  AddMorePetParents = 'addMorePetParents',
  DeletePetParentConfirmation = 'deletePetParentConfirmation',
  UploadFile = 'uploadFile',
  DragAndDropFile = 'dragAndDropFile',
  ClickToBrowse = 'clickToBrowse',
  SupportedFileTypes = 'supportedFileTypes',
  PetParentSubmissionSuccess = 'petParentSubmissionSuccess',
  EditPetParent = 'editPetParent',
  AddNewPetParent = 'addNewPetParent',
  ReviewPetParentInformation = 'reviewPetParentInformation',
  DeletePetParent = 'deletePetParent',
  DeletePetParentRecord = 'deletePetParentRecord',
  UploadASpreadsheet = 'uploadASpreadsheet',
  DragFileHereOrClickToUpload = 'dragFileHereOrClickToUpload',
  AcceptableFileTypes = 'acceptableFileTypes',
  Continue = 'continue',
  AdopterInfo = 'adopterInfo',
  PetInfo = 'petInfo',
  AdoptionDate = 'adoptionDate',
  AddMore = 'addMore',
  AdoptionModalSubText = 'AdoptionModalSubText',
  PetParentSubmissionMethodModalSubText = 'PetParentSubmissionMethodModalSubText',
  PetParentSubmissionMethodModalLearnMore = 'PetParentSubmissionMethodModalLearnMore',
  SubmitChanges = 'SubmitChanges',
  DiscardReport = 'DiscardReport',
  DiscardConfirmationMessage = 'DiscardConfirmationMessage',
  DiscardPetParentReportMessage = 'DiscardPetParentReportMessage',
  GoBack = 'GoBack',
  YesDiscard = 'YesDiscard',
  DeleteThisEntry = 'DeleteThisEntry',
  DeleteEntryMessage = 'DeleteEntryMessage',
  YesDelete = 'YesDelete',
  HroInformationModalTitle = 'HroInformationModalTitle',
  HroInformationModalDescription = 'HroInformationModalDescription',
  HroInformationModalButtonLabel = 'HroInformationModalButtonLabel',
  DoNotCloseModal = 'DoNotCloseModal',

  // Resources
  ResourcesTitle = 'resourcesTitle',
  UnleashYourTeamsPotential = 'unleashYourTeamsPotential',
  LoadingResources = 'loadingResources',
  ErrorLoadingResources = 'errorLoadingResources',
  NoResourcesDataAvailable = 'noResourcesDataAvailable',
  NoResourcesFound = 'noResourcesFound',
  DigitalToolkit = 'digitalToolkit',
  ProStaffFeeding = 'proStaffFeeding',
  ShopAndGiveBackProgram = 'shopAndGiveBackProgram',
  InitiativeSponsorship = 'initiativeSponsorship',
  AnimalWelfareResources = 'animalWelfareResources',
  HillsDisasterReliefNetwork = 'hillsDisasterReliefNetwork',
  FoodPantrySupport = 'foodPantrySupport',

  // Form labels
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Phone = 'phone',
  Address = 'address',
  City = 'city',
  State = 'state',
  ZipCode = 'zipCode',
  EmailAddress = 'emailAddress',
  PhoneNumber = 'phoneNumber',
  Species = 'species',
  PetName = 'petName',
  EstimatedBirthdate = 'estimatedBirthdate',
  AdoptionLocation = 'adoptionLocation',
  RetailPartner = 'retailPartner',
  RetailPartnerPlaceholder = 'RetailPartnerPlaceholder',

  // Manual Entry Modal
  PetParentInformation = 'petParentInformation',
  PetInformation = 'petInformation',
  PetNumberInformation = 'petNumberInformation',
  AddAnotherPetForParent = 'addAnotherPetForParent',
  ReviewAndSubmit = 'reviewAndSubmit',
  RemovePet = 'removePet',

  // Species Options
  Dog = 'dog',
  Cat = 'cat',
  Other = 'other',
  Canine = 'Canine',
  Feline = 'Feline',
  AdultSeniorDogs = 'AdultSeniorDogs',
  AdultSeniorCats = 'AdultSeniorCats',
  PuppiesLessThan1Year = 'PuppiesLessThan1Year',
  KittensLessThan1Year = 'KittensLessThan1Year',

  // Adoption Location Options
  ShelterAdoption = 'shelterAdoption',
  ShelterAdoptionDescription = 'shelterAdoptionDescription',
  AdoptionEvent = 'adoptionEvent',
  AdoptionEventDescription = 'adoptionEventDescription',
  RetailPartnerAdoption = 'retailPartnerAdoption',
  RetailPartnerAdoptionDescription = 'retailPartnerAdoptionDescription',

  // Error messages
  RequiredField = 'requiredField',
  InvalidEmail = 'invalidEmail',
  EmailAlreadyExists = 'EmailAlreadyExists',
  InvalidPhone = 'invalidPhone',
  GenericError = 'genericError',
  InvalidFileType = 'invalidFileType',
  FileTooLarge = 'fileTooLarge',
  ResolveErrorsBeforeSubmitting = 'resolveErrorsBeforeSubmitting',
  ResolveErrorBeforeSubmitting = 'resolveErrorBeforeSubmitting',
  ResolveMultipleErrorsBeforeSubmitting = 'resolveMultipleErrorsBeforeSubmitting',
  AuthenticationError = 'authenticationError',
  InvalidZipCode = 'invalidZipCode',
  BirthDateCannotBeFutureDate = 'BirthDateCannotBeFutureDate',
  AdoptionDateCannotBeFutureDate = 'AdoptionDateCannotBeFutureDate',
  BirthDateCannotBeAfterAdoptionDate = 'BirthDateCannotBeAfterAdoptionDate',
  InvalidName = 'invalidName',
  InvalidAddress = 'invalidAddress',
  InvalidCity = 'invalidCity',
  InvalidState = 'invalidState',
  DuplicatePetName = 'DuplicatePetName',
  InvalidPetSpecies = 'invalidPetSpecies',
  InvalidAdoptionLocation = 'invalidAdoptionLocation',
  InvalidDate = 'invalidDate',
  InvalidNumber = 'invalidNumber',
  NegativeNotAllowed = 'negativeNotAllowed',
  MustBeWholeNumber = 'mustBeWholeNumber',
  MoreErrorsSingular = 'moreErrorsSingular',
  MoreErrorsPlural = 'moreErrorsPlural',
  AccessRestricted = 'AccessRestricted',
  NotMVPUserMessage1 = 'notMVPUserMessage1',
  NotMVPUserMessage2 = 'notMVPUserMessage2',
  PageNotFoundMessage = 'PageNotFoundMessage',
  GoBackHome = 'GoBackHome',

  // Notifications
  SuccessfulSave = 'successfulSave',
  FailedSave = 'failedSave',
  SuccessfulDelete = 'successfulDelete',
  FailedDelete = 'failedDelete',

  // Modal
  ConfirmAction = 'confirmAction',
  ConfirmDelete = 'confirmDelete',

  // Insights
  PetParentOptInRate = 'petParentOptInRate',
  InsightsTotalOptIns = 'insightsTotalOptIns',
  TotalAdoptions = 'totalAdoptions',
  Total = 'Total',
  OptedInToHillsCommunications = 'optedInToHillsCommunications',
  ProgramTarget = 'programTarget',
  OptInRateTarget = 'optInRateTarget',
  AdoptionsIn = 'AdoptionsIn',
  AdultDogs = 'adultDogs',
  Puppies = 'puppies',
  AdultCats = 'adultCats',
  Kittens = 'kittens',
  Year = 'year',
  Quarter = 'quarter',
  Month = 'month',
  Jan = 'jan',
  Feb = 'feb',
  Mar = 'mar',
  Apr = 'apr',
  May = 'may',
  Jun = 'jun',
  Jul = 'jul',
  Aug = 'aug',
  Sep = 'sep',
  Oct = 'oct',
  Nov = 'nov',
  Dec = 'dec',
  WhatIsOptInRate = 'WhatIsOptInRate',
  OptInRateTooltipInfoLine1 = 'OptInRateTooltipInfoLine1',
  OptInRateTooltipInfoLine2 = 'OptInRateTooltipInfoLine2',
  OptInRateTooltipInfoLine3 = 'OptInRateTooltipInfoLine3',
  AdoptionsCardTooltip = 'AdoptionsCardTooltip',
  OptInRateNotAvailable = 'OptInRateNotAvailable',
  OptInRateNotApplicable = 'OptInRateNotApplicable',
  OptInRatePercentage = 'OptInRatePercentage',

  // Contact Us
  ContactUsDescription = 'contactUsDescription',
  FoodShelterLoveSupport = 'foodShelterLoveSupport',
  FoodShelterLoveSupportDescription = 'foodShelterLoveSupportDescription',
  SupportTime = 'supportTime',
  FoodShelterLoveMailDescription = 'foodShelterLoveMailDescription',

  // Banner
  ViewAndSubmit = 'viewAndSubmit',
  MissedReportSingular = 'missedReportSingular',
  MissedReportPlural = 'missedReportPlural',
  SubmitNowToStayInGoodStanding = 'submitNowToStayInGoodStanding',

  // Onboarding
  OnboardingTitle = 'onboardingTitle',
  OnboardingDescription = 'onboardingDescription',
  OnboardingButton = 'onboardingButton',

  // Tooltips
  DeadlinePassedTooltip = 'deadlinePassedTooltip',
  OrderCutOffDateTooltip = 'OrderCutOffDateTooltip',

  //Invalid Sold To Modal
  InvalidSoldToModalTitle = 'invalidSoldToModalTitle',
  InvalidSoldToModalDescription1 = 'invalidSoldToModalDescription1',
  InvalidSoldToModalContactSupport = 'invalidSoldToModalContactSupport',
  InvalidSoldToModalContactDayTime = 'invalidSoldToModalContactDayTime',
  InvalidSoldToModalLine1 = 'invalidSoldToModalLine1',
  InvalidSoldToModalLine2 = 'invalidSoldToModalLine2',

  //Access Restricted Modal
  AccessRestrictedModalTitle = 'AccessRestrictedModalTitle',
  AccessRestrictedModalDescriptionRetail1 = 'AccessRestrictedModalDescriptionRetail1',
  AccessRestrictedModalDescriptionRetail2 = 'AccessRestrictedModalDescriptionRetail2',
  AccessRestrictedModalDescriptionRetail3 = 'AccessRestrictedModalDescriptionRetail3',
  AccessRestrictedModalDescriptionOther = 'AccessRestrictedModalDescriptionOther',
  AccessRestrictedModalHillsRetail = 'AccessRestrictedModalHillsRetail',
  AccessRestrictedModalPortalName = 'AccessRestrictedModalPortalName',
  AccessRestrictedModalListHeader = 'AccessRestrictedModalListHeader',
  AccessRestrictedModalBullet1 = 'AccessRestrictedModalBullet1',
  AccessRestrictedModalBullet1Sub1 = 'AccessRestrictedModalBullet1Sub1',
  AccessRestrictedModalBullet1SubSignIn = 'AccessRestrictedModalBullet1SubSignIn',
  AccessRestrictedModalBullet1Sub2 = 'AccessRestrictedModalBullet1Sub2',
  AccessRestrictedModalBullet2 = 'AccessRestrictedModalBullet2',
  AccessRestrictedModalBullet2Sub2Beginning = 'AccessRestrictedModalBullet2Sub2Beginning',
  AccessRestrictedModalBullet2Sub2Register = 'AccessRestrictedModalBullet2Sub2Register',
  AccessRestrictedModalBullet2Sub2Middle = 'AccessRestrictedModalBullet2Sub2Middle',
  AccessRestrictedModalBullet2Sub2AccountNumber = 'AccessRestrictedModalBullet2Sub2AccountNumber',
  AccessRestrictedModalBullet2Sub2End = 'AccessRestrictedModalBullet2Sub2End',
  AccessRestrictedModalBullet2Sub2BillingZip = 'AccessRestrictedModalBullet2Sub2BillingZip',
  AccessRestrictedModalRetailBullet3 = 'AccessRestrictedModalRetailBullet3',
  AccessRestrictedModalRetailBullet3Sub3Beginning = 'AccessRestrictedModalRetailBullet3Sub3Beginning',
  AccessRestrictedModalRetailBullet3Sub3Apply = 'AccessRestrictedModalRetailBullet3Sub3Apply',
  AccessRestrictedModalRetailBullet3Sub3End = 'AccessRestrictedModalRetailBullet3Sub3End',
  AccessRestrictedModalSupport = 'AccessRestrictedModalSupport',
  AccessRestrictedModalToolTip = 'AccessRestrictedModalToolTip',

  // Maintenance Page
  MaintenancePageTitle = 'maintenancePageTitle',
  MaintenanceTitle = 'maintenanceTitle',
  MaintenanceDescription = 'maintenanceDescription',
  NeedImmediateAssistance = 'needImmediateAssistance',

  // Petszel Disabled Screens
  AutomateHillsReporting = 'automateHillsReporting',
  NewLabel = 'newLabel',
  PetszelDescription1 = 'petszelDescription1',
  PetszelDescription2 = 'petszelDescription2',
  PetszelDescription3 = 'petszelDescription3',
  HowProcessWork = 'howProcessWork',
  ProcessStep1Title = 'processStep1Title',
  ProcessStep1Description = 'processStep1Description',
  ProcessStep2Title = 'processStep2Title',
  ProcessStep2Description = 'processStep2Description',
  ProcessStep3Title = 'processStep3Title',
  ProcessStep3Description = 'processStep3Description',
  ConnectUsingPetszel = 'connectUsingPetszel',
  HillsAccountNumber = 'HillsAccountNumber',
  PetszelDisabledBannerDescription = 'petszelBannerDescription',

  // Compliance Warning Banner
  ComplianceWarningTitle = 'complianceWarningTitle',
  ComplianceWarningDescription = 'complianceWarningDescription',
  ComplianceWarningLinkText = 'complianceWarningLinkText',

  // Missed Month Warning Banner (Petszel-enabled shelters)
  MissedMonthWarningMessage = 'missedMonthWarningMessage',

  // Reporting Paused State
  ReportingPaused = 'reportingPaused',
  ReportingPausedBannerTitle = 'reportingPausedBannerTitle',
  ReportingPausedBannerSubtitle = 'reportingPausedBannerSubtitle',
  ReportingPausedBannerSubtitlePrefix = 'reportingPausedBannerSubtitlePrefix',
  ReportingPausedBannerSubtitleSuffix = 'reportingPausedBannerSubtitleSuffix',
  ReportingPausedTooltipTextPrefix = 'reportingPausedTooltipTextPrefix',
  ReportingPausedTooltipTextSuffix = 'reportingPausedTooltipTextSuffix',
  ContactHills = 'contactHills',
  LastUpdate = 'lastUpdate',
  Today = 'today',

  // Account Settings Page
  AccountInformation = 'AccountInformation',
  EditEmailContactLink = 'EditEmailContactLink',
  BillingInformation = 'BillingInformation',
  EditPaymentMethod = 'EditPaymentMethod',
  AllShippingAddresses = 'AllShippingAddresses',
  EditShippingAddress = 'EditShippingAddress',
  NoBillingInformation = 'NoBillingInformation',
  NoShippingAddresses = 'NoShippingAddresses',
  AccountNumber = 'AccountNumber',
  ShipToNumber = 'ShipToNumber',
  ProgramContract = 'ProgramContract',
  ViewOrRenewContractLabel = 'ViewOrRenewContractLabel',
  ViewOrRenewContractDescription = 'ViewOrRenewContractDescription',
  ContractAssistance = 'ContractAssistance',
  ViewContract = 'ViewContract',

  // Initialization
  InitializingApplication = 'initializingApplication',
  SettingUpExperience = 'settingUpExperience',
  LoadingFoodShelterLove = 'loadingFoodShelterLove',
  PleaseWaitPreparing = 'pleaseWaitPreparing',
  TakingLongerThanExpected = 'takingLongerThanExpected',

  // Canadian Form Fields
  Province = 'province',
  PostalCode = 'postalCode',
  PreferredLanguage = 'preferredLanguage',
  English = 'english',
  French = 'french',
  InvalidPostalCode = 'invalidPostalCode',
  InvalidPreferredLanguage = 'invalidPreferredLanguage',
  CanadianConsentStatement = 'canadianConsentStatement',
  BulkUploadCanadianHeader = 'bulkUploadCanadianHeader',
  BulkUploadCanadianLearnMore = 'bulkUploadCanadianLearnMore',
  
  // Canadian Provinces (for translation support)
  Alberta = 'alberta',
  BritishColumbia = 'britishColumbia',
  Manitoba = 'manitoba',
  NewBrunswick = 'newBrunswick',
  Newfoundland = 'newfoundland',
  NovaScotia = 'novaScotia',
  Ontario = 'ontario',
  PrinceEdwardIsland = 'princeEdwardIsland',
  Quebec = 'quebec',
  Saskatchewan = 'saskatchewan',
  NorthwestTerritories = 'northwestTerritories',
  Nunavut = 'nunavut',
  Yukon = 'yukon',

  // Digital Toolkit
  DigitalToolkitDescription = 'digitalToolkitDescription',
  DigitalToolkitTerms = 'digitalToolkitTerms',
  DownloadAll = 'downloadAll',
  Logos = 'logos',
  AdopterHandouts = 'adopterHandouts',

  // Dynamic/Generic Page States
  LoadingPage = 'loadingPage',
  ErrorLoadingPage = 'errorLoadingPage',
  FailedToLoadPageContent = 'failedToLoadPageContent',
  ResourcesComingSoon = 'resourcesComingSoon',
  FailedToLoadTutorials = 'failedToLoadTutorials',
  NoInsightsDataAvailable = 'noInsightsDataAvailable',

  // Application Page
  RedirectingToApplication = 'redirectingToApplication',
  LoadingApplicationForm = 'loadingApplicationForm',
  ApplicationFormSlowLoad = 'applicationFormSlowLoad',
  OpenInNewTab = 'openInNewTab',
  ApplicationFormTitle = 'applicationFormTitle',

  // Adoption Modal Titles
  SubmitAdoptionReport = 'submitAdoptionReport',
  AddMoreMonthAdoptions = 'addMoreMonthAdoptions',
  SubmitMonthAdoptions = 'submitMonthAdoptions',
  EditMonthAdoptions = 'editMonthAdoptions',
  MonthTotalAdoptions = 'monthTotalAdoptions',
  SubmitAdoptionsByDate = 'submitAdoptionsByDate',

  // Pet Parent Report Banners & Eyebrows
  AddNewPetParentsForTimeframe = 'addNewPetParentsForTimeframe',
  WeekOfTimeframe = 'weekOfTimeframe',

  // Home Page - Petszel Reports Section
  InMonth = 'inMonth',

  // Home Page - Canadian Order Section
  ContactInfo = 'contactInfo',

  // Home Page - Ship To Filter
  FailedToLoadLocations = 'failedToLoadLocations',

  // NonMVP User Modal
  HillsFSLProgramLinkText = 'hillsFSLProgramLinkText',
  Or = 'or',

  // Onboarding Modal
  BrowserDoesNotSupportVideo = 'browserDoesNotSupportVideo',

  // Spreadsheet Upload Modal
  Processing = 'processing',
  ProcessingFile = 'processingFile',
  SecondsLeft = 'secondsLeft',

  // Review Pet Parent Modal
  AgeSingularYear = 'ageSingularYear',
  AgePluralYears = 'agePluralYears',

  // Manual Entry Modal
  ErrorsToFix = 'errorsToFix',

  // Page Not Found
  PageNotFoundAlt = 'pageNotFoundAlt',

  // Banner
  Close = 'close',

  // Accessibility
  Actions = 'actions',
  MainNavigation = 'mainNavigation',
}

export type Translations = {
  [key in TranslationKeyEnum]?: string;
};
